import { render, staticRenderFns } from "./CardProductThemePc.vue?vue&type=template&id=19feb5dc&scoped=true"
import script from "./CardProductThemePc.vue?vue&type=script&lang=js"
export * from "./CardProductThemePc.vue?vue&type=script&lang=js"
import style0 from "./CardProductThemePc.vue?vue&type=style&index=0&id=19feb5dc&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19feb5dc",
  null
  
)

export default component.exports